<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import {
  computed,
  defineEmits,
  ref
} from 'vue';

import CardComponent from '@/components/ui/CardComponent.vue';
import { ExportFormatKey } from "@/enums/fees_enum.ts";

const { t } = useI18n();

const emits = defineEmits(['closeModal']);

const props = defineProps<{
  title: string;
  message: string;
}>();

const selectedExportFormat = ref<ExportFormatKey>(ExportFormatKey.CSV);
const exportOptions = computed(() => [
  { title: 'CSV', value: ExportFormatKey.CSV },
  { title: 'XLSX', value: ExportFormatKey.XLSX },
  { title: 'PDF', value: ExportFormatKey.PDF },
]);
</script>

<template>
  <v-form class="w-100 d-flex align-center">
    <CardComponent with-actions>
      <template #title>
        <span class="text-wrap">{{ props.title }}</span>
      </template>
      <template #item>
        <p class="mb-4">
          {{ props.message }}
        </p>

        <!-- Select export format -->
        <v-select
          v-model="selectedExportFormat"
          :items="exportOptions"
          :label="t('views.mandateFees.modal.format')"
          item-title="title"
          item-value="value"
          variant="outlined"
          density="compact"
          hide-details
          class="mt-2"
        />
      </template>
      <template #actions>
        <div class="d-flex flex-row justify-space-between ga-4 mt-2">
          <v-btn
            variant="outlined"
            @click.prevent="emits('closeModal', false)"
          >
            {{ t('common.buttons.cancel') }}
          </v-btn>
          <v-btn
            type="submit"
            variant="flat"
            color="primary"
            @click="emits('closeModal', selectedExportFormat)"
          >
            {{ t('common.buttons.validate') }}
          </v-btn>
        </div>
      </template>
    </CardComponent>
  </v-form>
</template>
